module.exports = __webpack_public_path__ + "static/media/apple-podcast.264d63bb.svg";